import { defineComponent as _defineComponent } from 'vue'
import { PropType } from "vue";
import QExpandableDataTable from "../../../components/datatables/QExpandableDataTable.vue";
import { MetricValues, WriterCentricMetrics } from "../api";
import { useColumnAverage, useColumnAveragePercent } from "../composables/useColumnAverage";
import { toRef } from "vue";
import BlueBox from "./BlueBox.vue";
import AgentNameCol from "./AgentNameCol.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AoWriterDataTable',
  props: {
  items: { type: Array as PropType<(WriterCentricMetrics)[]>, default: () => [] },
},
  setup(__props) {

const props = __props



const headers = [
	{
		text: "Agent Name",
		value: "AgentName",
	},
	{
		text: "APV Per Writer",
		value: "MonthlyAPVPerWriter",
	},
	{
		text: "Apps Per Writer",
		value: "MonthlyAppsPerWriter",
	},
	{
		text: "Writers Currently Active",
		value: "ActiveWritersPerWriter",
	},
	{
		text: "Writers to SNA",
		value: "SNAsPerWriter",
	},
	{
		text: "Average",
		value: "Average",
	},
];

// const top10ApvWriters = useColumnAverage(toRef(props, 'items'), 'MonthlyAPVPerWriter', 'MonthlyAPVPerWriter')
// const top10ActivePercent = useColumnAveragePercent(toRef(props, 'items'), 'ActiveWritersPerWriter')
// const top10WriterPercent = useColumnAveragePercent(toRef(props, 'items'), 'SNAsPerWriter')
// const top10AppWriters = useColumnAverage(toRef(props, 'items'), 'MonthlyAppsPerWriter')
// const top10DaysToWriter = useColumnAverage(toRef(props, 'items'), 'PerWriter')

return { __sfc: true,props, headers, QExpandableDataTable, AgentNameCol }
}

})